import { useState } from "react";
import type { ShiftFormDocumentSettings } from "../../../shared/shift-production-form/contracts";

type EditableSettings = Pick<
  ShiftFormDocumentSettings,
  "documentNo" | "publicationDate" | "revisionDate" | "revisionNo"
>;

type Props = {
  settings: ShiftFormDocumentSettings;
  busy: boolean;
  onSave: (
    settings: EditableSettings,
    expectedVersion: number,
  ) => Promise<{ settings: ShiftFormDocumentSettings | null; conflict: boolean }>;
  onReload: () => Promise<void>;
};

export function DocumentSettingsForm({
  settings,
  busy,
  onSave,
  onReload,
}: Props) {
  const [draft, setDraft] = useState<EditableSettings>(editable(settings));
  const [conflict, setConflict] = useState(false);
  const submit = async () => {
    const response = await onSave(draft, settings.version);
    setConflict(response.conflict);
    if (response.settings) setDraft(editable(response.settings));
  };
  return (
    <section className="shift-admin-section">
      <h3>Doküman bilgileri</h3>
      <p>Bu bilgiler yeni formlara ve yeniden kaydedilen taslaklara uygulanır. Onaylanmış raporların geçmiş bilgileri korunur.</p>
      <form
        className="shift-form-grid"
        onSubmit={(event) => {
          event.preventDefault();
          void submit();
        }}
      >
        <label className="shift-form-field">
          <span>Doküman No</span>
          <input value={draft.documentNo ?? ""} onChange={(event) => setDraft({ ...draft, documentNo: event.target.value || null })} />
        </label>
        <label className="shift-form-field">
          <span>Yayın Tarihi</span>
          <input type="date" required value={draft.publicationDate} onChange={(event) => setDraft({ ...draft, publicationDate: event.target.value })} />
        </label>
        <label className="shift-form-field">
          <span>Revizyon Tarihi</span>
          <input type="date" required value={draft.revisionDate} onChange={(event) => setDraft({ ...draft, revisionDate: event.target.value })} />
        </label>
        <label className="shift-form-field">
          <span>Revizyon No</span>
          <input value={draft.revisionNo ?? ""} onChange={(event) => setDraft({ ...draft, revisionNo: event.target.value || null })} />
        </label>
        <button className="shift-form-primary" disabled={busy} type="submit">Doküman bilgilerini kaydet</button>
      </form>
      {conflict ? (
        <p className="shift-form-error" role="alert">
          Güncel bilgileri yükleyip yazdıklarınızı kontrol edin.
          <button type="button" disabled={busy} onClick={() => void onReload()}>Güncel bilgileri yükle</button>
        </p>
      ) : null}
    </section>
  );
}

function editable(settings: ShiftFormDocumentSettings): EditableSettings {
  return {
    documentNo: settings.documentNo,
    publicationDate: settings.publicationDate,
    revisionDate: settings.revisionDate,
    revisionNo: settings.revisionNo,
  };
}
